import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function GenericTooltip({ children, tip, placement = "bottom", delayShow = 100, delayHide = 250 }) {

    const renderTooltip = function (props) {
        return (
            <Tooltip{...props}><span>{tip}</span></Tooltip>
        )
    }

    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: delayShow, hide: delayHide }}
            overlay={renderTooltip}
        ><span>{children}</span></OverlayTrigger>
    )
}

export default GenericTooltip